/**
 * CopyButton — T24.
 *
 * Copies the rendered output markdown to clipboard.
 * Calls onCopied() after a successful copy so the parent can trigger the
 * "Copied" state in CostLabel for 2s.
 */
import { Button } from '@mantine/core';

interface CopyButtonProps {
  text: string;
  onCopied: () => void;
  disabled?: boolean;
}

export function CopyButton({ text, onCopied, disabled = false }: CopyButtonProps) {
  async function handleClick() {
    if (!text) return;
    try {
      await navigator.clipboard.writeText(text);
      onCopied();
    } catch {
      // Clipboard write failed (e.g. in tests / no permission) — silently ignore
    }
  }

  return (
    <Button
      variant="default"
      size="xs"
      onClick={handleClick}
      disabled={disabled}
      data-testid="copy-btn"
    >
      Copy
    </Button>
  );
}
